/**
 * Nombre de un municipio tal como se lee en la interfaz.
 *
 * En la base viene en mayúsculas (DIVIPOLA: "CHINCHINÁ"); en minúsculas con
 * CSS `capitalize` se lee "Chinchiná". Es el mismo criterio del encabezado
 * de la ficha (`FichaHeader`). Nació en `ScoreHero` con el issue #726 y se
 * comparte desde el #746, cuando las demás tarjetas de la ficha de otro
 * municipio empezaron a nombrarlo.
 */
export function NombreMunicipio({ nombre }: { nombre: string }) {
  return <span className="capitalize">{nombre.toLowerCase()}</span>;
}
